<template>
  <div class="app-main-content importingTemplate">
    <div class="grid-view">
      <div class="main-content">
        <div class="section operations" style="height: 39px;">
          <div class="triggers">
            <div>
              <span style="display: inline-block;width: 50px;color: #333333">{{ $t('common.btn.query') }}</span>
              <el-input v-model="inputVal" style="width: 286px;" :placeholder="$t('CargoMsg.Cargo_PleaseQuery')" />
              <el-button type="primary" size="mini" @click="query(false)">{{ $t('common.btn.query') }}</el-button>
              <el-button type="primary" size="mini" @click="add">{{ $t('common.btn.new') }}</el-button>
              <el-button type="primary" :disabled="selectedCount === 0 || (tenantId === 1 && $store.getters.tenantId !== 1)" size="mini" @click="edit">{{ $t('common.btn.edit') }}</el-button>
              <el-button type="primary" :disabled="selectedCount === 0" size="mini" @click="copy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
              <el-button type="danger" :disabled="!isChecked || (tenantId === 1 && $store.getters.tenantId !== 1)" size="mini" @click="deletes">{{ $t('common.btn.delete') }}</el-button>
              <!-- 在平台维护中不显示该勾选框 -->
              <el-checkbox v-if="$store.getters.tenantId !== 1" v-model="checked" style="margin-left:10px;" @change="prefabrication">{{ $t('CargoMsg.Cargo_HiddenPlatform') }}</el-checkbox>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            config-module="191263"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="022060523"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="query(true)"
          />
        </div>
      </div>
    </div>
    <!-- 添加、编辑窗口 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="newPlan"
      :close-on-click-modal="false"
      :title="$t('CargoMsg.Cargo_AddNewTemplate')"
      :editable="true"
      :modal-append-to-body="false"
      width="800px;"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;display: flex;flex-direction: column;">
        <div class="filters">
          <el-form :inline="true" :model="dialogForm" label-position="left" @submit.native.prevent>
            <el-form-item :label="$t('CargoMsg.Cargo_ProductName')" class="setStyle">
              <el-input v-model="dialogForm.templateName" type="text" style="width: 180px;" :placeholder="$t('CargoMsg.Cargo_PleaseEnterPlanName')" />
            </el-form-item>

            <el-form-item :label="$t('CargoMsg.Cargo_PlanDescription')" style="margin-left:20px;">
              <el-input v-model="dialogForm.templateDescribe" type="text" style="width: 180px;" :placeholder="$t('CargoMsg.Cargo_PleaseEnterPlanRemark')" />
            </el-form-item>
            <div>
              <span style="display:block;margin:20px 0;color:#000;">{{ $t('CargoMsg.Cargo_ImportTableSet') }}</span>
              <el-form-item :label="$t('CargoMsg.Cargo_StartLine2')" class="setStyle">
                <el-input v-model="dialogForm.startRow" type="number" :style="{width: isZh ? '100px': '200px'}" :placeholder="$t('CargoMsg.Cargo_PleaseEnterStartLine')" />
              </el-form-item>
            </div>

            <div style="display:flex;align-items: center;">
              <el-checkbox v-model="dialogForm.openFilterRule" @change="changed">{{ $t('CargoMsg.Cargo_EnableFilterRowRule') }}</el-checkbox>
              <el-tooltip class="item" effect="dark" :content="$t('CargoMsg.Cargo_ImportColumnsFilterOut')" placement="top-end">
                <i class="el-icon-question" style="color: #46a6ff;margin-bottom: 10px;" />
              </el-tooltip>
              <div v-show="dialogForm.openFilterRule" style="margin-left:20px;">
                <span>{{ $t('CargoMsg.Cargo_SpaceGreaterThan') }}</span>
                <el-input v-model="dialogForm.blankAccountFor" type="number" style="width:50px;margin: 0 10px;" /> %
              </div>
            </div>

          </el-form>
        </div>
        <div style="margin-top:20px;">
          <p style="color:red;margin:0 0 5px 0;">{{ $t('CargoMsg.Cargo_PleaseEnterHeaderName') }}</p>
          <p style="color:red;margin:0 0 5px 0;">{{ $t('CargoMsg.Cargo_PleaseEnterHeaderGridNum') }}</p>
          <cargo-ag-grid
            config-module="191264"
            :grid-options="dialogGridOptions"
            :column-defs="dialogColumnDefs"
            :row-data="dialogForm.templateMappingVoList"
          />
        </div>
        <div style="display: flex;justify-content: space-between;margin-top:20px;">
          <div>
            <el-button type="primary" size="mini" @click="dialogAdd">{{ $t('CargoMsg.Cargo_add') }}</el-button>
            <el-button type="danger" size="mini" :disabled="!dialogSelectedCount" @click="dialogDelete">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
          <div>
            <el-button type="primary" size="mini" @click="dialogConfirm()">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
            <el-button size="mini" @click="dialogCancel()">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import { getGridSelected } from '@/utils/agGrid'
import { saveTemplate, deleteTemplate, updateTemplate, queryTemplateList, deleteTemplateMapping, updateTemplateHideState, getInitialCheckValue } from '@/api/ImportingTemplate'

export default {
  name: 'ImportingTemplate',
  data() {
    return {
      tenantId: '',
      checked: '',
      dialogFormStatusMap: {
        create: 1,
        edit: 2
      },
      selectedCount: 0,
      dialogSelectedCount: 0,
      dialogFormStatus: 'create',
      inputVal: '',
      newPlan: false,
      serialNum: 0,
      dialogForm: {
        templateName: '',
        templateDescribe: '',
        startRow: '',
        openFilterRule: true,
        blankAccountFor: 50,
        templateMappingVoList: []
      },
      uuidList: [],
      // 分页
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SerialNo'),
          field: 'serialNum',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TemplateName'),
          field: 'templateName',
          width: 150
        }
      ],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          console.log('rows', rows)
          // tenantId为1 代表预制模板，勾选的数据中有预制的模板，则置灰编辑和删除按钮
          if (rows.find(item => item.tenantId === 1)) {
            this.tenantId = 1
          } else {
            this.tenantId = ''
          }
          if (rows.length > 0) {
            this.isChecked = true
          } else {
            this.isChecked = false
          }
          this.selectedCount = rows.length
        },
        onRowClicked: (params) => {
          console.log('params', params)
          const data = getGridSelected(this.gridOptions)
          if (data.length === 0) {
            if (params.data) {
              this.selectedCount = 1
            }
            this.selectedRows = params.data
            this.tenantId = params.data.tenantId
          }
        }
      },
      isChecked: false,
      selectedRows: {},
      serialNumber: [],
      rowData: [],
      options: [
        {
          tableColumnName: 'MBL NO',
          value: 'MBL',
          checked: true,
          id: 1
        },
        {
          tableColumnName: 'SO NO',
          value: 'SONO',
          id: 2
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_ChargeName'),
          value: 'CHARGEITEMNAME',
          id: 3
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_Currency'),
          value: 'CURRENCY',
          id: 4
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_Amount'),
          value: 'AMOUNT',
          id: 5
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_ContainerNo'),
          value: 'CONTAINERNO',
          id: 6
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
          value: 'VESSEL',
          id: 7
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_VoyageNo'),
          value: 'VOYAGE_FLIGHT',
          id: 8
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_BusinessNo'),
          value: 'JOBNO',
          id: 9
        },
        {
          tableColumnName: this.$t('Invoice.invoice_invoiceNo'),
          value: 'INVOICENO',
          id: 10
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_UnitPrice'),
          value: 'CHARGE_UNIT_RATE',
          id: 11
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_AmountNumber'),
          value: 'CHARGE_QUANTITY',
          id: 12
        },
        {
          tableColumnName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          value: 'WAREHOUSE_NO',
          id: 13
        },
        {
          tableColumnName: this.$t('SeaExport.HblNo'),
          value: 'HBL_NBR2',
          id: 14
        },
        {
          tableColumnName: this.$t('SeaExport.BusinessReferenceNo'),
          value: 'CUSTOMER_REF_NO',
          id: 15
        },
        {
          tableColumnName: this.$t('SeaExport.Operation'),
          value: 'OP_NAME',
          id: 16
        }
      ],
      arr: [],
      dialogGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          if (rows.length === this.dialogForm.templateMappingVoList.length || rows.length === 0) {
            this.dialogSelectedCount = 0
          } else {
            this.dialogSelectedCount = 1
          }
        },
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridSelectEditor
        }
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    tableColumnNameObj() {
      const obj = {}
      this.options.map((item) => {
        obj[item.tableColumnName] = item.value
      })
      return obj
    },
    tableColumnNameValObj() {
      const obj = {}
      this.options.map((item) => {
        obj[item.value] = item.tableColumnName
      })
      return obj
    },
    dialogColumnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SerialNo'),
          field: 'serialNumber',
          lockVisible: true,
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InternalTableName'),
          headerClass: 'setStyle',
          field: 'tableColumnName',
          colId: 'tableColumnName',
          editable: true,
          lockVisible: true,
          singleClickEdit: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: false
            },
            options: this.selectOptions,
            tagName: 'tableColumnName',
            tagValue: 'tableColumnName'
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            const index = this.arr.findIndex((item) => {
              return item === params.oldValue
            })
            if (index >= 0) {
              const newArr = this.arr.slice(0)
              newArr.splice(index, 1)
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.arr = newArr
            }
          },
          valueFormatter: params => {
            if (!this.arr.includes(params.value)) {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.arr.push(params.value)
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExcelCellName'),
          headerClass: 'setStyle',
          field: 'excelColumnName',
          lockVisible: true,
          width: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: false }
        }
      ]
    },
    selectOptions() {
      return this.options.map((item) => {
        if (!this.arr.includes(item.tableColumnName)) {
          return item
        }
      }).filter(_ => _)
    }
  },
  created() {
    this.query(false)
    this.getInitialCheckValueFunc()
  },
  methods: {
    // 获取是否勾选了隐藏预制模板
    async getInitialCheckValueFunc() {
      const res = await getInitialCheckValue()
      if (res.ok) {
        this.checked = res.data
      }
    },
    // 勾选预制模板
    async prefabrication(value) {
      const data = {
        hide: value
      }
      const res = await updateTemplateHideState(data)
      if (res.ok) {
        this.query(false)
      }
    },
    // 查询
    async query(pageQuery = false) {
      const data = {
        templateName: this.inputVal.trim(),
        tenantId: this.$store.getters.tenantId,
        branchId: this.$store.getters.userId,
        ...this.searchConditions
      }
      if (!pageQuery) {
        data.pageNum = 1
      }
      const res = await queryTemplateList(data)
      if (res.ok && res.data.total > 0) {
        this.selectedCount = 0
        this.isChecked = false
        this.searchConditions.total = Number(res.data.total)
        this.rowData = res.data && res.data.list || []
        this.rowData?.map((item, index) => {
          return (item.serialNum = index + 1)
        })
      } else {
        this.searchConditions = {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
        this.rowData = []
      }
    },
    // 新增
    add() {
      this.dialogSelectedCount = 0
      this.newPlan = true
      this.dialogFormStatus = 'create'
      this.resetForm()
      this.dialogAdd()
      this.uuidList = []
      this.serialNum = 0
      this.gridOptions.api.deselectAll()
    },
    // 编辑
    async edit() {
      const data = await getGridSelected(this.gridOptions)
      if (data.length > 1) {
        this.$message.warning(this.$t('Information.CannotEditMultipleSchemes'))
      } else {
        if (!this.isChecked) {
          this.dialogForm = JSON.parse(JSON.stringify(this.selectedRows))
        } else {
          this.dialogForm = { ...JSON.parse(JSON.stringify(data[0])) }
        }
        this.dialogForm.blankAccountFor = this.dialogForm.blankAccountFor * 100
        this.dialogSelectedCount = 0
        this.dialogFormStatus = 'edit'
        this.newPlan = true
        this.uuidList = []
        this.arr = []
        this.dialogForm.templateMappingVoList?.map((item, index) => {
          item.tableColumnName = this.tableColumnNameValObj[item.tableColumnName]
          this.arr.push(item.tableColumnName)
          item.serialNumber = index + 1
          item.id = index
        })
      }
    },
    // 复制
    async copy() {
      const data = await getGridSelected(this.gridOptions)
      if (data.length > 1) {
        this.$message.warning(this.$t('Information.CannotCopyMultipleSchemes'))
      } else {
        this.dialogSelectedCount = 0
        if (!this.isChecked) {
          this.dialogForm = JSON.parse(JSON.stringify(this.selectedRows))
        } else {
          this.dialogForm = { ...JSON.parse(JSON.stringify(data[0])) }
        }
        delete this.dialogForm.uuid
        delete this.dialogForm.templateUuid
        this.dialogForm.blankAccountFor = this.dialogForm.blankAccountFor * 100
        this.dialogForm.templateName = ''
        this.dialogFormStatus = 'create'
        this.newPlan = true
        this.uuidList = []
        this.arr = []
        this.dialogForm.templateMappingVoList?.map((item, index) => {
          delete item.uuid
          delete item.templateUuid
          item.tableColumnName = this.tableColumnNameValObj[item.tableColumnName]
          this.arr.push(item.tableColumnName)
          item.serialNumber = index + 1
          item.id = index
        })
      }
    },
    // 删除
    async deletes() {
      const data = getGridSelected(this.gridOptions)
      const uuidList = data.map(_ => {
        return _.uuid
      })
      const res = await deleteTemplate(uuidList)
      if (res.ok) {
        this.$message.success(this.$t('Information.DeletedSuccessfully'))
        this.query(false)
      }
    },
    // 弹窗添加按钮
    dialogAdd() {
      if (this.selectOptions.length === 0) {
        return
      }
      this.dialogForm.templateMappingVoList.push({
        serialNumber: '',
        tableColumnName: this.selectOptions[0].tableColumnName,
        excelColumnName: '',
        templateUuid: this.dialogForm.uuid,
        tenantId: this.dialogForm.tenantId
      })
      this.dialogForm.templateMappingVoList.map((item, index) => {
        item.serialNumber = index + 1
        item.id = index
      })
    },
    // 弹窗删除按钮
    dialogDelete() {
      const self = this
      const data = getGridSelected(self.dialogGridOptions)
      if (data.length === 0) {
        return
      }
      let i = 1
      // 保存删除的id
      data.map(_ => {
        if (_.uuid) {
          self.uuidList.push(_.uuid)
        }
      })
      self.serialNumber = data.map(_ => {
        return _.id
      })
      self.dialogForm.templateMappingVoList = self.dialogForm.templateMappingVoList.filter((item) => {
        const newArr = this.arr.map((i) => {
          if (i !== item.tableColumnName) {
            return item
          }
        }).filter(_ => _)
        this.arr = newArr
        if (!self.serialNumber.includes(item.id)) {
          item.serialNumber = i++
          return true
        }
      })
    },
    // 弹窗映射关系删除
    async dialogDeleteFunc() {
      const res = await deleteTemplateMapping(this.uuidList)
      if (res.ok) {
        this.uuidList = []
        console.log('删除成功')
      }
    },
    // 弹窗确定按钮
    async dialogConfirm() {
      const self = this
      if (!self.dialogForm.templateName) {
        self.$message.warning(this.$t('Information.PleaseEnterTheSchemeName'))
        return false
      }
      if (!self.dialogForm.startRow) {
        self.$message.warning(this.$t('Information.PleaseEnterTheStartingRow'))
        return false
      }
      const length = self.dialogForm.templateMappingVoList.length
      if (length > 0 && self.dialogForm.templateMappingVoList.find(target => target.excelColumnName === '')) {
        self.$message.warning(this.$t('Information.PleaseTheExcelCellName'))
        return false
      }
      if (this.dialogForm.openFilterRule && !this.dialogForm.blankAccountFor) {
        self.$message.warning(this.$t('Information.PleaseEnterTheSpaceProportion'))
        return false
      }
      let res = {}
      const data = JSON.parse(JSON.stringify(self.dialogForm))
      if (length > 0) {
        data.templateMappingVoList.map((item) => {
          item.tableColumnName = self.tableColumnNameObj[item.tableColumnName]
        })
      }
      if (data.openFilterRule) {
        data.blankAccountFor = data.blankAccountFor / 100
      }
      if (self.dialogFormStatus === 'create') {
        const newData = {
          templateName: data.templateName,
          templateDescribe: data.templateDescribe,
          startRow: data.startRow,
          openFilterRule: data.openFilterRule,
          blankAccountFor: data.blankAccountFor,
          templateMappingVoList: data.templateMappingVoList
        }
        res = await saveTemplate(newData)
      } else {
        res = await updateTemplate(data)
        if (self.uuidList.length !== 0) {
          await self.dialogDeleteFunc()
        }
      }
      if (res.ok) {
        self.newPlan = false
        await self.query(false)
        self.resetForm()
      }
    },
    // 弹窗取消按钮
    dialogCancel() {
      this.newPlan = false
      this.uuidList = []
      this.gridOptions.api.deselectAll()
    },
    resetForm() {
      this.dialogForm.templateName = ''
      this.dialogForm.templateDescribe = ''
      this.dialogForm.startRow = ''
      this.dialogForm.openFilterRule = true
      this.dialogForm.blankAccountFor = 50
      this.dialogForm.uuid = ''
      this.arr = []
      this.dialogForm.templateMappingVoList = []
    },
    changed(value) {
      if (!value) {
        this.dialogForm.blankAccountFor = ''
      }
    }
  }

}
</script>
<style lang="scss">
.importingTemplate{
  .setStyle{
    color: #4283ff;
    .el-form-item__label{
      color: #4283ff !important;
    }
  }
}

</style>

